


























































































































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';
//@ts-ignore
import formPoaAvanceFinanciero from '@/components/formPoaAvanceFinanciero'

//@ts-ignore
import poa_lineas_accion from '@/mixins/axios/poa_lineas_accion'
//@ts-ignore
import indicador_administradores from '@/mixins/axios/indicador_administradores'

//@ts-ignore
import poa_clasif_programaticas from '@/mixins/axios/poa_clasif_programaticas'
//@ts-ignore
import poa_finalidades from '@/mixins/axios/poa_finalidades'
//@ts-ignore
import poa_funciones from '@/mixins/axios/poa_funciones'
//@ts-ignore
import poa_subfunciones from '@/mixins/axios/poa_subfunciones'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import poa_eje_estraegia from '@/mixins/axios/poa_eje_estraegia'

//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'
//@ts-ignore
import poa_actividades_lineas_accion from '@/mixins/axios/poa_actividades_lineas_accion'
//@ts-ignore
import PoaLineaAccion from '@/components/headersSelect/poalineaaccion'
//@ts-ignore
import pmds from '@/mixins/axios/pmds'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
        PoaLineaAccion,
    formPoaAvanceFinanciero,
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
            
             {
                tag:'nombre',
                data:'nombre',
                active:false
            }, {
                tag:'linea',
                data:'linea',
                active:false
            },
            {
                tag:'select_pmd_estr_eje',
                data:'select_pmd_estr_eje',
                active:false
            },
             {
                tag:'select2',
                data:'select2',
                active:false
            },
           
            /*
           
            {
                tag:'idprogramatica',
                data:'programatica',
                active:true
            },
            {
                tag:'poblacion_objetivo',
                data:'poblacion_objetivo',
                active:true
            },
            {
                tag:'tipo_poblacion',
                data:'tipo_poblacion',
                active:true
            },
            {
                tag:'meta',
                data:'meta',
                active:true
            },
            {
                tag:'finalidad',
                data:'finalidad',
                active:true
            },
            {
                tag:'funciones',
                data:'funciones',
                active:true
            },
            {
                tag:'subfunciones',
                data:'subfunciones',
                active:true
            },*/
                 {
                tag:'delete',
                data:'delete',
                active:false
            },
             {
                tag:'edit',
                data:'edit',
                active:false
            },
           
        ],

poa_actividades_lineas_accion:false,
 statusmodal:0,

        id:null as any,
     pmd_id:null as any,
      nombre:null as any,
       idprogramatica:0,  
       poblacion_objetivo:null as any,
      tipo_poblacion:0,
       meta:null as any,
        idfinalidades:0,
         idfunciones:0,
          idsubfunciones:0,
          poa_eje_estraegiadata:[],
          poa_lineas_acciones_id:null as any,
          estrategias_id:null as any,
          ejes_id:null as any,
ejedata:[],
estrategiadata:[],
         statusmodal:0,
          indicador_administradores_id:0,
         poa_lineas_acciones_id:null as any,
          nombrelinea:null as any,
              poa_lineaacciondata:[] as any,
                 poa_clasif_programaticas:[] as any,
                    poa_finalidades:[] as any,
                       poa_funciones:[] as any,
                          poa_subfunciones:[] as any,
                          id_finalidad:0,
      indicador_administradores:[]as any,
        pmds:[] as any,
    }
  },
     mixins: [poa_lineas_accion,poa_clasif_programaticas,
     poa_finalidades,poa_funciones,poa_subfunciones,indicador_administradores,pmds,poa_eje_estraegia],
     validations: {
    
           nombre: {
      required,
    },
      idprogramatica: {
      required,
    },
    poblacion_objetivo: {
      required,
    },
      indicador_administradores_id: {
      required,
    },
      tipo_poblacion: {
      required,
    },
      meta: {
      required,
    },
      idfinalidades: {
      required,
    },
      idfunciones: {
      required,
    },
      idsubfunciones: {
      required,
    },
  pmd_id: {
      required,
    },
     

   
  },
  methods:{

 onChangeFun(event){
//console.log(event.target.value)
this.id_finalidad=event.target.value;

this.getDataSub(event.target.value);
},
onChangeFin(event){
//console.log(event.target.value)
this.getDataFunciones(event.target.value);
},
async getDataSub(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
      idfinalidades:this.idfinalidades,
idfunciones:id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};
console.log(data2, ' lo que trae dataaaaaaaaaaaaaa 2')
let data= await this.GET_POA_SUBFUNCIONES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_subfunciones=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async getDataFunciones(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
    idfinalidades:id,
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_POA_FUNCIONES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        this.poa_funciones=response;
                        if(response.length>0){

this.getDataSub(response[0].id);
                        }


                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
 async getDataFinalidades() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_POA_FINALIDADES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_finalidades=response;
this.getDataFunciones(response[0].id);
this.getDataSub(response[0].id2);
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},





































async eliminarEje(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_POA_EJE_EST(row).then(response => {

                    if (response != null) {

 this.poa_eje_estraegiadata=this.poa_eje_estraegiadata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirmEje(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminarEje(row);
    },function(){ 
      
        
    });



      
     },


        async crearEje(){
           
        
            let dat={
estrategias_id:this.estrategias_id,
 ejes_id:this.ejes_id,
poa_lineas_acciones_id: this.poa_lineas_acciones_id
            };

let data= await this.CREAR_POA_EJE_EST(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.poa_eje_estraegiadata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear, refresque la pagina");

                    }    $("#modalCausa").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
      setpmd_estr_eje(row){

this.getDataejeest(row);

 this.poa_lineas_acciones_id=row.id;


    
 $('#ac_eje_est').modal('show')
   

},
async getDataejeest(row) {
    this.poa_lineas_acciones_id=row.id;
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={

poa_lineas_acciones_id: this.poa_lineas_acciones_id
};

let data= await this.GET_POA_EJE_EST(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_eje_estraegiadata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

 onChangeEje(event){
//console.log(event.target.value)
this.getDataEstrategia(event.target.value);
},
async getDataEstrategia(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
ideje:id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_PMD_ESTRATEGIA(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.estrategiadata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async getDataEje() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_PMD_EJE(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.ejedata=response;
this.getDataEstrategia(response[0].id);
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



















onChangePMD(event){
//console.log(event.target.value)
this.getDatapmd(event.target.value);

},
async getDatapmd() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_PMDS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.pmds=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

onChangeAdmi(event){
//console.log(event.target.value)
this.getDataAdministra(event.target.value);

},
      
       async getDataAdministra(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data3={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_ADMINISTRADORES(data3).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_administradores=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},


        clearstate(){
this.$store.commit('SETLINEAACCION',null);
 this.$router.push('/mun/poa/poas/lineas')
        },
         select2(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETLINEAACCION',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/poa/poas/lineas/actividadlineas')
//this.getDataDepartamentos();

     },

 onChangeP(event){
//console.log(event.target.value)
this.getDataProgramatica(event.target.value);

},
       async getDataProgramatica(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_POA_CLASIF_PROGRAMATICA(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_clasif_programaticas=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_POA_LINEAS_ACCION(row).then(response => {

                    if (response != null) {

 this.poa_lineaacciondata=this.poa_lineaacciondata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 this.pmd_id=null;
           
                 this.nombre=null;

                 this.idprogramatica=0;

                 this.poblacion_objetivo=null;

                 this.tipo_poblacion=0;

                 this.meta=null;

                 this.idfinalidades=0;

                 this.idfunciones=0;

                 this.idsubfunciones=0;

              
                 this.indicador_administradores_id=0;

        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_linea_accion').modal('show')
      },
seteditar(row){

console.log(row,'----------------------ll----')
 this.id=row.id;

 this.pmd_id=row.pmd_id;
  this.nombre=row.nombre;
   this.idprogramatica=row.idprogramatica;
    this.poblacion_objetivo=row.poblacion_objetivo;
     this.tipo_poblacion=row.tipo_poblacion;
      this.meta=row.meta;
       this.idfinalidades=row.idfinalidades;
        this.idfunciones=row.idfunciones;
         this.idsubfunciones=row.idsubfunciones;
              this.indicador_administradores_id=row.indicador_administradores_id;
          
 $('#ac_modal_linea_accion').modal('show')
    

},

setlinea(row){      
    
     this.statusmodal=this.statusmodal+1;
       this.poa_lineas_acciones_id= row.id;    
         this.nombrelinea= row.nombre;  
this.indicador_administradores_id= row.indicador_administradores_id;  
 $('#modalCausa').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_POA_LINEAS_ACCION(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.poa_lineaacciondata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Poa Lineas Acción, refresque la pagina");

                    }    $("#modalCausa").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_POA_LINEAS_ACCION(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicador de areas modificado exitosamente, refresque la pagina");
  this.poa_lineaacciondata=this.poa_lineaacciondata.filter(item => item.id !== dat.id);
 this.poa_lineaacciondata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Poa Lineas Acción, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
           
           nombre:this.nombre,
             pmd_id:this.pmd_id,
             idprogramatica:this.idprogramatica,
               poblacion_objetivo:this.poblacion_objetivo,
                 tipo_poblacion:this.tipo_poblacion,
                   meta:this.meta,
                     idfinalidades:this.idfinalidades,
                       idfunciones:this.idfunciones,
                         idsubfunciones:this.idsubfunciones,
                         indicador_administradores_id:this.indicador_administradores_id,
           poas_id:this.$store.state.poa_sel.id,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
poas_id:this.$store.state.poa_sel.id,
};

let data= await this.GET_POA_LINEAS_ACCION(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_lineaacciondata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
async getDataActividadLinea() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let dat={
poa_lineas_acciones_id:this.$store.state.linea_accion_sel.id,


};

let data= await this.GET_POA_ACTIVIDADES_LINEAS_ACCION(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_actividades_lineas_accion=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
}


  },
  created(){
this.$store.commit('SETLINEAACCION',null);
 this.$router.push('/mun/poa/poas/lineas')
  },
  mounted(){
      this.getData();
      this.getDataFinalidades();
      this.getDataProgramatica();
      this.getDataAdministra();
      this.getDatapmd();
      this.getDataEje();
      //alert('10')0
  }
})
export default class Home extends Vue {}

